"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRendererContext = exports.RendererProvider = void 0;
var react_1 = __importStar(require("react"));
var missingRendererProvider = 
/* istanbul ignore next: RendererProvider is required */ function () {
    throw new Error('Missing RendererProvider');
};
var rendererContext = (0, react_1.createContext)({
    getState: missingRendererProvider,
    renderSceneSurface: missingRendererProvider,
    measureTextWidth: missingRendererProvider,
    resourceContext: {
        isFontLoaded: missingRendererProvider,
        getFont: missingRendererProvider,
        loadFont: missingRendererProvider,
        registerFont: missingRendererProvider,
        isImageLoaded: missingRendererProvider,
        getImage: missingRendererProvider,
        loadImage: missingRendererProvider,
        registerImage: missingRendererProvider,
    },
});
var RendererProvider = function (_a) {
    var children = _a.children, getState = _a.getState, renderSceneSurface = _a.renderSceneSurface, measureTextWidth = _a.measureTextWidth, resourceContext = _a.resourceContext;
    var value = (0, react_1.useMemo)(function () { return ({ getState: getState, renderSceneSurface: renderSceneSurface, measureTextWidth: measureTextWidth, resourceContext: resourceContext }); }, [getState, renderSceneSurface, measureTextWidth, resourceContext]);
    return (react_1.default.createElement(rendererContext.Provider, { value: value }, children));
};
exports.RendererProvider = RendererProvider;
var useRendererContext = function () { return (0, react_1.useContext)(rendererContext); };
exports.useRendererContext = useRendererContext;
